import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Tours from "@/pages/Tours";
import TourBooking from "@/pages/TourBooking";
import BuggyBooking from "@/pages/BuggyBooking";
import Dining from "@/pages/Dining";
import Confirmation from "@/pages/Confirmation";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminOperations from "@/pages/AdminOperations";
import AdminSideEvent from "@/pages/AdminSideEvent";
import MarketingQR from "@/pages/MarketingQR";
import RoadTrip from "@/pages/RoadTrip";
import ActivityLog from "@/pages/ActivityLog";
import RefundsCancellations from "@/pages/RefundsCancellations";
import DiningSalesReport from "@/pages/DiningSalesReport";
import TourSalesReport from "@/pages/TourSalesReport";
import RestaurantCheckin from "@/pages/RestaurantCheckin";
import Rebook from "@/pages/Rebook";
import Reschedule from "@/pages/Reschedule";
import ChangeApproval from "@/pages/ChangeApproval";
import StaffCheckin from "@/pages/StaffCheckin";
import ScanCheckin from "@/pages/ScanCheckin";
import PartnerScan from "@/pages/PartnerScan";
import ProtectedRoute from "@/components/ProtectedRoute";
import TrafficTracker from "@/components/TrafficTracker";

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main className="pt-20">{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-background grain">
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-center" />
          <TrafficTracker />
          <Routes>
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/tours" element={<PublicLayout><Tours /></PublicLayout>} />
            <Route path="/tours/buggy" element={<PublicLayout><BuggyBooking /></PublicLayout>} />
            <Route path="/tours/:tourId" element={<PublicLayout><TourBooking /></PublicLayout>} />
            <Route path="/dining" element={<PublicLayout><Dining /></PublicLayout>} />
            <Route path="/road-trip" element={<PublicLayout><RoadTrip /></PublicLayout>} />
            <Route path="/confirmation/:bookingId" element={<PublicLayout><Confirmation /></PublicLayout>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/operations" element={<ProtectedRoute><AdminOperations /></ProtectedRoute>} />
            <Route path="/admin/side-event" element={<ProtectedRoute><AdminSideEvent /></ProtectedRoute>} />
            <Route path="/admin/marketing" element={<ProtectedRoute><MarketingQR /></ProtectedRoute>} />
            <Route path="/admin/activity-log" element={<ProtectedRoute><ActivityLog /></ProtectedRoute>} />
            <Route path="/admin/refunds" element={<ProtectedRoute><RefundsCancellations /></ProtectedRoute>} />
            <Route path="/admin/dining-sales" element={<ProtectedRoute><DiningSalesReport /></ProtectedRoute>} />
            <Route path="/admin/tour-sales" element={<ProtectedRoute><TourSalesReport /></ProtectedRoute>} />
            <Route path="/change/:token" element={<ChangeApproval />} />
            <Route path="/rebook/:token" element={<Rebook />} />
            <Route path="/reschedule/:token" element={<Reschedule />} />
            <Route path="/staff/checkin/:bookingId" element={<ProtectedRoute><StaffCheckin /></ProtectedRoute>} />
            <Route path="/admin/scan" element={<ProtectedRoute><ScanCheckin /></ProtectedRoute>} />
            <Route path="/partner/:token" element={<PartnerScan />} />
            <Route path="/restaurant/:token" element={<RestaurantCheckin />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
